import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "~/components/ui/button";
import { ModalFooter, ModalHeader, ModalTitle } from "~/components/ui/modal";

type ConfirmDeleteFinancialAdjustmentModalProps = {
  closeModal: (confirm: boolean) => void;
};

export const ConfirmDeleteFinancialAdjustmentModal: React.FC<
  ConfirmDeleteFinancialAdjustmentModalProps
> = ({ closeModal }) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col justify-between overflow-hidden">
      <div className="p-10">
        <ModalHeader>
          <ModalTitle>
            {t("invoice.confirm_delete_financial_adjustment.title")}
          </ModalTitle>
        </ModalHeader>
        <div className="mb-12 text-sm text-gray-700">
          {t("invoice.confirm_delete_financial_adjustment.text")}
        </div>
      </div>
      <ModalFooter>
        <Button
          type="button"
          variant="outline"
          onClick={() => closeModal(false)}
          tabIndex={-1}
        >
          {t("cancel")}
        </Button>
        <Button
          type="submit"
          variant="destructive"
          onClick={() => closeModal(true)}
        >
          {t("invoice.confirm_delete_financial_adjustment.delete")}
        </Button>
      </ModalFooter>
    </div>
  );
};
